export default __webpack_public_path__ + "static/tasks-eb9639882edf2848c1ec8a07633a104d.svg";